import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface ResourceItem {
    id: string;
    name: string;
}

interface ResourceNavNodeProps {
    resourceName: string;
    resourcePath: string;
    items: ResourceItem[];
    onItemSelect?: (itemId: string) => void;
    showItemCount?: boolean;
}

const ResourceNavNode: React.FC<ResourceNavNodeProps> = ({
    resourceName,
    resourcePath,
    items,
    onItemSelect,
    showItemCount = true
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const displayItems = items.slice(0, 3);
    const hasMore = items.length > 3;

    return (
        <div className="resource-nav-node">
            <div className="resource-nav-node__header">
                <Link
                    to={resourcePath}
                    className="resource-nav-node__link"
                    onClick={() => {
                        if (items.length > 0) {
                            setIsExpanded(true);
                        }
                    }}
                >
                    {resourceName}{showItemCount ? ` (${items.length})` : ''}
                </Link>
                <button hidden={items.length === 0}
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="resource-nav-node__toggle"
                >
                    {isExpanded ? '▼' : '▶'}
                </button>
            </div>

            {isExpanded && displayItems.length > 0 && (
                <div className="resource-nav-node__items">
                    {displayItems.map((item) => (
                        <div
                            key={item.id}
                            onClick={() => onItemSelect?.(item.id)}
                            className="resource-nav-node__item"
                        >
                            <Link to={`${resourcePath}/${item.id}`}>
                                {item.name}
                            </Link>
                        </div>
                    ))}

                    {hasMore && (
                        <Link
                            to={resourcePath}
                            className="resource-nav-node__more"
                        >
                            ...
                        </Link>
                    )}
                </div>
            )}
        </div>
    );
};

export default ResourceNavNode;